import { useCallback } from "react";
import { useSelector } from "react-redux";

import { selectorSetting } from "@/shared/store/settings/selectors";
import { SETTING } from "@/shared/utils/settings/constants";
import { DefaultFontSize } from "@/shared/utils/theme/theme";

export const useRemToPx = () => {
  const zoom = useSelector(selectorSetting(SETTING.zoom.id));

  const remToPx = useCallback((remValue) => {
    return (remValue * DefaultFontSize * zoom) / 100;
  }, [zoom]);

  return remToPx;
};
